import * as Yup from "yup";

const AnnouncementSchema = Yup.object().shape({
  title: Yup.string().required("Required"),
  message: Yup.string().required("Required"),
  from_date_time: Yup.string().required("Required"),
  to_date_time: Yup.string().required("Required"),
});

export default AnnouncementSchema;
